"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _echarts = _interopRequireDefault(require("echarts"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('echarts/theme/macarons'); // echarts theme
var _default = exports.default = {
  name: 'dayMoney',
  components: {
    drawer: _filter.default
  },
  data: function data() {
    var _this = this;
    return {
      loading: false,
      chartLoading: false,
      // 添加图表加载状态变量
      form: {
        role_id: '2',
        // 设置默认角色类型为"城市合伙人"
        begin: new Date(new Date().setDate(new Date().getDate() - 6)),
        // 设置默认开始时间为7天前
        end: new Date(),
        // 设置默认结束时间为当天
        search_type: '' // 默认为全部
      },
      list: [],
      tableList: [],
      listQuery: {},
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime() + 86400;
          }
        }
      },
      // 新增数据属性用于存储柱状图数据
      barChartData: []
    };
  },
  mounted: function mounted() {
    this.getList(); // 获取列表
    this.getBarChartData(); // 获取柱状图数据
  },
  methods: {
    /**
     * 项目类型改变时触发查询
     */
    onSearchTypeChange: function onSearchTypeChange() {
      this.getBarChartData();
    },
    /**
     * 设置今日时间
     */
    setToday: function setToday() {
      var today = new Date();
      this.form.begin = today;
      this.form.end = today;
      this.toQuery();
    },
    /**
     * 设置昨日时间
     */
    setYesterday: function setYesterday() {
      var today = new Date();
      var yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      this.form.begin = yesterday;
      this.form.end = yesterday;
      this.toQuery();
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // 重置
      if (type == 1) {
        // 重置表单
        this.form = {
          role_id: '2',
          // 设置默认角色类型为"城市合伙人"
          begin: new Date(new Date().setDate(new Date().getDate() - 6)),
          // 设置默认开始时间为7天前
          end: new Date(),
          // 设置默认结束时间为当天
          search_type: '' // 重置项目类型为全部
        };
      }
      // 重置分页
      this.listQuery.start = 1;
      // 获取列表
      this.getList();
      // 获取柱状图数据
      this.getBarChartData();
    },
    getList: function getList() {
      var _this2 = this;
      var url = 'agentapi/statistics/my_order_date_data';
      // 复制form对象但排除空的search_type值
      var listQuery = Object.assign({}, this.form, this.listQuery);
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');

      // 如果search_type为空字符串，不传递该参数
      if (listQuery.search_type === '') {
        delete listQuery.search_type;
      }

      // 显示loading状态
      this.loading = true;
      this.$get(url, listQuery).then(function (res) {
        _this2.list = Object.values(JSON.parse(JSON.stringify(res))).reverse();
        _this2.tableList = Object.values(res);
      }).catch(function () {}).finally(function () {
        // 隐藏loading状态
        _this2.loading = false;
      });
    },
    // 获取柱状图数据
    getBarChartData: function getBarChartData() {
      var _this3 = this;
      // 显示图表loading状态
      this.chartLoading = true;

      // 直接从时间戳或默认值构造日期字符串，避免任何时区转换

      // 如果有开始时间，则使用该日期构造 00:00:01 时间
      // 否则使用 30 天前的日期构造 00:00:01 时间
      var startTime;
      if (this.form.begin) {
        var startDate = new Date(this.form.begin);
        var year = startDate.getFullYear();
        var month = String(startDate.getMonth() + 1).padStart(2, '0');
        var day = String(startDate.getDate()).padStart(2, '0');
        startTime = "".concat(year, "-").concat(month, "-").concat(day, " 00:00:01");
      } else {
        var defaultStartDate = new Date();
        defaultStartDate.setDate(defaultStartDate.getDate() - 30);
        var _year = defaultStartDate.getFullYear();
        var _month = String(defaultStartDate.getMonth() + 1).padStart(2, '0');
        var _day = String(defaultStartDate.getDate()).padStart(2, '0');
        startTime = "".concat(_year, "-").concat(_month, "-").concat(_day, " 00:00:01");
      }

      // 如果有结束时间，则使用该日期构造 23:59:59 时间
      // 否则使用今天日期构造 23:59:59 时间
      var endTime;
      if (this.form.end) {
        var endDate = new Date(this.form.end);
        var _year2 = endDate.getFullYear();
        var _month2 = String(endDate.getMonth() + 1).padStart(2, '0');
        var _day2 = String(endDate.getDate()).padStart(2, '0');
        endTime = "".concat(_year2, "-").concat(_month2, "-").concat(_day2, " 23:59:59");
      } else {
        var defaultEndDate = new Date();
        var _year3 = defaultEndDate.getFullYear();
        var _month3 = String(defaultEndDate.getMonth() + 1).padStart(2, '0');
        var _day3 = String(defaultEndDate.getDate()).padStart(2, '0');
        endTime = "".concat(_year3, "-").concat(_month3, "-").concat(_day3, " 23:59:59");
      }
      var url = 'agentapi/pay/store_pay_group';
      var params = {
        start_time: startTime,
        end_time: endTime,
        role_id: this.form.role_id || '0' // 添加角色类型筛选参数
      };

      // 添加项目类型筛选参数（如果非空）
      if (this.form.search_type !== '') {
        params.search_type = this.form.search_type;
      }
      this.$get(url, params).then(function (res) {
        _this3.barChartData = res;
        _this3.initBarChart();
      }).catch(function (error) {
        console.error('获取柱状图数据失败:', error);
        _this3.$message.error('获取柱状图数据失败，请稍后重试');
      }).finally(function () {
        // 隐藏图表loading状态
        _this3.chartLoading = false;
      });
    },
    // 初始化柱状图
    initBarChart: function initBarChart() {
      var chartDom = document.getElementById('moneyChart');
      var myChart = _echarts.default.init(chartDom, 'macarons');

      // 每次初始化前先清空图表
      myChart.clear();

      // 检查是否有数据
      if (!this.barChartData || this.barChartData.length === 0) {
        // 显示"暂无数据"提示
        myChart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 16
            }
          }
        });
        return;
      }

      // 提取数据
      var names = this.barChartData.map(function (item) {
        return item.name;
      });
      var incomes = this.barChartData.map(function (item) {
        return parseFloat(item.net_income);
      });

      // 检查处理后的数据是否为空
      if (names.length === 0 || incomes.length === 0) {
        // 显示"暂无数据"提示
        myChart.setOption({
          title: {
            text: '暂无数据',
            left: 'center',
            top: 'center',
            textStyle: {
              color: '#999',
              fontSize: 16
            }
          }
        });
        return;
      }

      // 计算总交易额
      var totalIncome = incomes.reduce(function (sum, income) {
        return sum + income;
      }, 0);

      // 计算每个柱子的百分比
      var percentages = incomes.map(function (income) {
        return totalIncome ? (income / totalIncome * 100).toFixed(2) : 0;
      });

      // 创建自定义的x轴标签，将百分比显示在名称下方
      var customXAxisData = names.map(function (name, index) {
        return {
          value: name,
          // 添加百分比信息到标签中
          percentage: "".concat(percentages[index], "%")
        };
      });
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '20%',
          // 增加底部空间以容纳x轴标签
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: customXAxisData,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            rotate: 0,
            interval: 0,
            fontSize: 10,
            // 自定义标签显示，将百分比显示在名称下方
            formatter: function formatter(value, index) {
              var item = customXAxisData[index];
              return "".concat(item.value, "\n(").concat(item.percentage, ")");
            }
          }
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} 元'
          }
        }],
        dataZoom: [{
          show: true,
          realtime: true,
          start: 0,
          end: Math.min(1, Math.max(21, 100 / (names.length / 21))) // 默认显示21个元素
        }],
        series: [{
          name: '交易额',
          type: 'bar',
          barWidth: '60%',
          data: incomes,
          itemStyle: {
            color: '#3888fa'
          },
          label: {
            show: true,
            position: 'top',
            formatter: function formatter(params) {
              // 显示实际金额值
              return "".concat(params.value, "\u5143");
            }
          }
        }]
      };
      myChart.setOption(option);
    }
    /*
    // 废弃的折线图相关代码
     initChart() {
      const that = this
      this.chart = echarts.init(document.getElementById('moneyChart'), 'macarons')
      this.chart.setOption({
        xAxis: {
          type: 'category',
          data: that.day,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        yAxis: {
          axisTick: {
            show: false
          },
          type: 'value'
        },
        grid: {
          left: 20,
          right: 20,
          bottom: 20,
          top: 40,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100
          }
        ],
        legend: {
          data: ['总交易额', '总收益额', '总订单量']
        },
        series: [
          {
            name: '总交易额',
            itemStyle: {
              normal: {
                color: '#3888fa',
                lineStyle: {
                  color: '#3888fa',
                  width: 2
                },
                areaStyle: {
                  color: '#f3f8ff'
                }
              }
            },
            smooth: true,
            type: 'line',
            data: this.day_order_amount,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          }, {
            name: '总收益额',
            smooth: true,
            type: 'line',
            data: this.day_profit,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          }, {
            name: '总订单量',
            smooth: true,
            type: 'line',
            data: this.day_order_num,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          }
        ]
      })
    }
    */
  }
};